import { Box, Container, Stack } from "@mui/system";
import React from "react";
import { FaTelegram } from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";
import { FaSquareXTwitter } from "react-icons/fa6";
import { Divider, Grid, Typography } from "@mui/material";
import { boy } from "./SmallComponents/Images";

function Footer() {
  return (
    <Box
      mb={-1}
      sx={{
        mt: { xs: 10, md: 20 },
        background: "#27ADFB",
      }}
    >
      <Container maxWidth="xl" pb={0}>
        <Grid container justifyContent={"center"}>
          <Grid item xs={10}>
            <Box pt={3}>
              <Typography
                sx={{
                  textAlign: "left",
                  fontFamily: "Lilita One",
                  fontSize: { md: "40px", xs: "22px" },
                  fontWeight: "400",
                  color: "#fff",
                }}
              >
                BARFBOY
              </Typography>
              <Stack flexDirection={"row"} gap={2}>
                <a
                  href="https://www.instagram.com/BARFBOYmemecoin/?igsh=OW80c3FyZGY0dXY1&utm_source=qr#"
                  target="_blank"
                  style={{
                    textDecoration: "none",
                  }}
                  rel="noreferrer"
                >
                  <AiFillInstagram
                    style={{ fontSize: "33px", color: "#ffff" }}
                  />
                </a>
                <a
                  href="https://t.me/BARFBOYofficial"
                  target="_blank"
                  style={{
                    textDecoration: "none",
                  }}
                  rel="noreferrer"
                >
                  <FaTelegram style={{ fontSize: "30px", color: "#ffff" }} />
                </a>

                <a
                  href="https://x.com/BARFBOYSOL"
                  target="_blank"
                  style={{ textDecoration: "none" }}
                  rel="noreferrer"
                >
                  <FaSquareXTwitter
                    style={{ fontSize: "30px", color: "#ffff" }}
                  />
                </a>
              </Stack>
              <Divider
                sx={{
                  my: 2,
                  background: "#ffffff",
                }}
              />
              <Typography
                sx={{
                  color: "#FFFFFF",
                  fontSize: { xs: "10px", sm: "13px" },
                  fontFamily: "Montserrat",
                }}
              >
                © 2024 BARFBOY • All Rights Reserved
              </Typography>
            </Box>
          </Grid>

          <Grid
            item
            xs={2}
            sx={{
              display: "flex",
              justifyContent: "end",
              alignItems: "end",
            }}
          >
            <Box
              mt={{ xs: -10, md: -20 }}
              ml={{ xs: 0, sm: -12, md: -6 }}
              mr={{ xs: -1.5, sm: 0 }}
              component={"img"}
              alt=""
              src={boy}
              borderRadius="50px"
              width={{ xs: "150px", sm: "200px", md: "250px" }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Footer;
